import { SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { MesLista } from "@/Models/geral/data/Mes";

export interface IMesSelect extends Omit<React.ComponentProps<typeof SelectComPesquisa>, "dataSource"> {

}

export default function MesSelect({
    placeholder,
    onChange, 
    value,
    ...rest
}:IMesSelect) {
    return <SelectComPesquisa 
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear
        loading={false}
        options={MesLista}
        onChange={onChange}
        value={value}
    />
}